import React from 'react';
import { SvgIcon } from '@mui/material';
import styles from './iconStyles';

function SupplierCenterActive() {
  return (
    <SvgIcon style={styles.icon}>
      <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <title>Warehouse</title>
        <desc>Created with Sketch.</desc>
        <g id="Supplier-center-active" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="box-2" transform="translate(2.000000, 2.000000)" fillRule="nonzero">
            <path
              d="M13.0833333,4.16666667 L19.5,4.16666667 L14.75,0.166666667 C14.5833333,0.0833333333 14.3333333,0 14.1666667,0 L11.5,0 L13.0833333,4.16666667 Z"
              id="Path"
              fill="#FFFFFF"
            />
            <path
              d="M13.3333333,5.83333333 L13.3333333,11.6666667 L6.66666667,11.6666667 L6.66666667,5.83333333 L0,5.83333333 L0,19.1666667 C0,19.6666667 0.333333333,20 0.833333333,20 L19.1666667,20 C19.6666667,20 20,19.6666667 20,19.1666667 L20,5.83333333 L13.3333333,5.83333333 Z"
              id="Path"
              fill="currentColor"
            />
            <path
              d="M6.91666667,4.16666667 L8.5,0 L5.83333333,0 C5.66666667,0 5.41666667,0.0833333333 5.33333333,0.166666667 L0.5,4.16666667 L6.91666667,4.16666667 Z"
              id="Path"
              fill="#FFFFFF"
            />
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
}

export default SupplierCenterActive;
